// Root Redux Store Provider
import React from 'react';
import {Provider} from 'react-redux';

const Root = ({store,children})=>{
  return <Provider store={store}>{children}</Provider>
}

export default Root;